"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Scale, Car, Briefcase, Tractor, HeartCrack, Stethoscope } from "lucide-react";
const services = [{
  id: 1,
  title: "Odszkodowania z OC sprawcy",
  description: "Kompleksowa pomoc prawna w sprawach o odszkodowanie wynikające z odpowiedzialności cywilnej sprawcy. Analiza dokumentacji, reprezentacja przed ubezpieczycielem i sądem.",
  icon: Scale
}, {
  id: 2,
  title: "Wypadki komunikacyjne",
  description: "Reprezentacja osób poszkodowanych w wypadkach drogowych – kierowców, pasażerów, pieszych i rowerzystów. Ocena odpowiedzialności sprawcy i dochodzenie świadczeń.",
  icon: Car
}, {
  id: 3,
  title: "Wypadki przy pracy",
  description: "Prowadzenie spraw dotyczących wypadków przy pracy, analiza odpowiedzialności pracodawcy oraz pomoc w dochodzeniu roszczeń z tytułu odniesionych obrażeń.",
  icon: Briefcase
}, {
  id: 4,
  title: "Wypadki rolnicze i KRUS",
  description: "Pomoc osobom poszkodowanym w gospodarstwach rolnych. Sprawy związane z odpowiedzialnością ubezpieczeniową i świadczeniami z KRUS.",
  icon: Tractor
}, {
  id: 5,
  title: "Śmierć osoby bliskiej i błędy medyczne",
  description: "Reprezentacja członków rodzin po śmierci bliskich oraz prowadzenie spraw dotyczących odpowiedzialności za zdarzenia medyczne z analizą dokumentacji.",
  icon: HeartCrack
}];
export default function NaszeUslugiSzczegoly() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="nasze-usługi-szczegóły" ref={sectionRef} className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className={`mb-12 md:mb-16 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold text-foreground mb-4">Nasze usługi - szczegóły</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Kompleksowa pomoc prawna dla osób poszkodowanych w różnych sytuacjach życiowych
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          const {
            ref: cardRef,
            isVisible: cardVisible
          } = useRevealOnScroll({
            once: true,
            threshold: 0.2
          });
          return <div key={service.id} data-index={i} ref={cardRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i >= 3 ? "md:col-span-1 lg:col-start-auto" : ""}`} style={{
            transitionDelay: cardVisible ? `${i * 80}ms` : "0ms"
          }}>
                <Card className="h-full group hover-lift">
                  <CardHeader>
                    <div className="mb-4 inline-flex">
                      <Icon className="w-12 h-12 stroke-[1.5] text-primary group-hover:text-secondary transition-colors duration-[var(--duration-fast)]" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl md:text-2xl text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-base text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <Link to="/ContactPage" className="btn-primary inline-flex items-center justify-center">
            Skontaktuj się z nami
          </Link>
        </div>
      </div>
    </section>;
}